module.exports = __webpack_public_path__ + "static/navsync-9a6f71522c1321809c87e4147178204d.mp4";